import { useMutation } from '@tanstack/react-query';
import {
  bookingDtoSchema,
  type BookingDto,
  type CreateBookingRequest,
} from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

export function useCreateBooking() {
  return useMutation<BookingDto, unknown, CreateBookingRequest>({
    mutationFn: async (payload) => {
      const res = await api.post('/bookings', payload);
      return bookingDtoSchema.parse(res.data);
    },
  });
}
